import Vue from 'vue'

const state = {
    defaultSegment:{
        name: '',
    },
    segments: null,
    selectedSegment: null,
};

const getters = {
    getSegments: (state, rootstate) => {
        if(!state.segments || state.segments.length == 0) return []
        return state.segments
    },
    getDefaultSegment: (state) => state.defaultSegment,
    getSelectedSegment: (state) => state.selectedSegment,
};

const actions = {
    downloadSegments ({state, rootState, commit}){
        if(!rootState.user.account.supplierId){
            return false
        }

        return axios.get('/api/Supplier/GetSegments', {
            params: {
                supplierId: rootState.user.account.supplierId
            }
        }).then(response => {
            if(response.status == 200){

                var output = response.data

                commit('SET_SEGMENTS', output)
            }
        })


    },
    setSelectedSegment ({ state }, payload) {
        state.selectedSegment = payload
    },

    createSegment ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/CreateSegment', {
            supplierId: rootState.user.account.supplierId,
            segment: payload
        }).then(response => {
            if(response.status == 200){
                commit('ADD_SEGMENT', response.data)
            }
        })
    },

    updateSegment ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/EditSegment', {
            supplierId: rootState.user.account.supplierId,
            segment: payload
        }).then(response => {
            if(response.status == 200){
                commit('UPDATE_SEGMENT', response.data)
                return true
            }
            return false
        })
    },

    deleteSegment ({ state, rootState, commit }, payload) {
        return axios.post('/api/Supplier/DeleteSegment', {
            supplierId: rootState.user.account.supplierId,
            segment: payload
        }).then(response => {
            if(response.status == 200){
                if(response.data == true){
                    commit('REMOVE_SEGMENT', payload)
                }
            }
        })
    },
};

const mutations = {
    SET_SEGMENTS: (state, payload) => {
        state.segments = payload;
    },

    ADD_SEGMENT: (state, payload) => {
        state.segments.push(payload)
    },

    REMOVE_SEGMENT: (state, payload) => {
        let index = state.segments.indexOf(payload)
        state.segments.splice(index, 1)
    },
	UPDATE_SEGMENT: (state, payload) => {
		const index = state.segments.indexOf(payload);
		const updatedSegments = [...state.segments]; // Create a copy of the segments array
		updatedSegments.splice(index, 1, payload); // Replace the segment at the found index with the new payload

		// Return a new state object with the updated segments array
		return {
			...state,
			segments: updatedSegments
		};
	}


};

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/segments.js